import { Card, CardContent } from '@lensora/ui'
import { Lock } from 'lucide-react'

export function McpUpsellCard() {
  return (
    <Card className="border-feedback-info/30 bg-feedback-info/5">
      <CardContent className="flex items-start gap-3 pt-6">
        <Lock className="mt-0.5 h-5 w-5 shrink-0 text-feedback-info" />
        <p className="text-sm text-text">
          Connecting external clients (Claude, ChatGPT, Cursor, n8n) to your Lenora data via MCP
          isn't enabled on your plan.{' '}
          <a href="/dashboard/settings/billing" className="text-brand-accent underline">
            Upgrade your plan
          </a>{' '}
          to create new keys. Existing keys below remain listable and revocable.
        </p>
      </CardContent>
    </Card>
  )
}
